import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base.service";
import { catchError, finalize, map } from "rxjs/operators";
import { Competence } from "../domain/competence";
import { MatSnackBar } from "@angular/material/snack-bar";
import { mapper } from "../tools/mapping/mapper";
import { CompetenceDTO } from "./dto/competence.dto";

@Injectable({
    providedIn: 'root',
})
export class MasterCompetenceService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/mastercompetence`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {
        super(router, coreData, snackBare);
    }

    getMasterCompetenceList() {

        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/active`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getMasterCompetenceList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: CompetenceDTO[]) => {
                return response.map((item: CompetenceDTO) => {
                    return mapper.map(item, CompetenceDTO, Competence);
                });
            }));
    }
}